import React from 'react'
import Footer from './Footer'
import { useHistory, useLocation } from 'react-router-dom'
import idDirectory from './idAttributes'
import useFeatureToggle from 'hooks/FeatureToggles/useFeatureToggles'

const StandardFooter = () => {
    const { enabled, footerTitle, positionRight } = useFeatureToggle(
        'MAIN_FOOTER'
    )

    const history = useHistory()
    const { pathname } = useLocation()

    if (!enabled) return null

    return (
        <Footer
            id={idDirectory.footer}
            className={'emp-standardFooter-root'}
            style={{ textAlign: positionRight && 'right' }}
        >
            <span
                id={idDirectory.link}
                onClick={() =>
                    pathname !== '/terms-of-use' &&
                    history.push('/terms-of-use')
                }
                className={
                    pathname === '/terms-of-use'
                        ? ' emp-standardFooter-link-active'
                        : 'emp-standardFooter-link'
                }
            >
                Terms of Use
            </span>

            <span
                id={idDirectory.link}
                onClick={() =>
                    pathname !== '/privacy-policy' &&
                    history.push('/privacy-policy')
                }
                className={
                    pathname === '/privacy-policy'
                        ? ' emp-standardFooter-link-active'
                        : 'emp-standardFooter-link'
                }
            >
                Privacy Policy
            </span>

            {footerTitle}
        </Footer>
    )
}

export default StandardFooter
